import { styled, Grid } from '@mui/material';
import React from 'react';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../../utils/constants/Constants.js';
import { GenericContainer } from '../GenericContainer.js';

var _a, _b;
var ThreeSpotlightContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var SpotlightHeader = styled('div')((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'center',
        fontSize: 50,
        fontWeight: 700
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 30,
    },
    _a));
var SpotlightContainer = styled(Grid)((_b = {
        //   display: 'flex',
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'relative'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
        alignItems: 'center',
    },
    _b['.tech_star_top'] = {
        left: 0,
        top: 5,
        position: 'absolute',
    },
    _b['.tech_star_bot'] = {
        right: 0,
        bottom: -15,
        position: 'absolute',
    },
    _b));
var TileContainer = styled(Grid)({
    maxWidth: 300,
    textAlign: 'center',
    marginTop: 50,
    gap: '5px',
    '.header': { fontSize: 23, fontWeight: 700, lineLheight: 1.7 },
    '.desc': { fontSize: 18, fontWeight: 500, lineLheight: 1.63 },
    '.img_container': {
        width: '100%',
        height: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 20,
        marginBottom: 20,
        img: {
            maxWidth: 300,
            maxHeight: 300,
        },
    },
});
var Tile = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, children = _a.children;
    return (React.createElement(TileContainer, { container: true, flexDirection: 'column', alignItems: 'center' },
        React.createElement("div", { className: "img_container" }, children),
        React.createElement("div", { className: "header" }, title),
        React.createElement("div", { className: "desc" }, subtitle)));
};
var BrandclubThreeSpotlightWidget = function (_a) {
    var header = _a.header, spotlight1 = _a.spotlight1, spotlight2 = _a.spotlight2, spotlight3 = _a.spotlight3, _b = _a.showStarts, showStarts = _b === void 0 ? false : _b;
    return (React.createElement(ThreeSpotlightContainer, null,
        React.createElement(SpotlightHeader, null, header),
        React.createElement(SpotlightContainer, { container: true, wrap: "nowrap" },
            showStarts && (React.createElement("img", { loading: "lazy", className: "tech_star_top", alt: "tech_star_top", src: "https://media.brandclub.com/brandclub/image_asset/tech_star_top.svg" })),
            showStarts && (React.createElement("img", { loading: "lazy", className: "tech_star_bot", alt: "tech_star_bot", src: "https://media.brandclub.com/brandclub/image_asset/tech_star_bot.svg" })),
            React.createElement(Tile, { title: spotlight1.title, subtitle: spotlight1.subtitle }, React.createElement(spotlight1.ImgWidget, null)),
            React.createElement(Tile, { title: spotlight2.title, subtitle: spotlight2.subtitle }, React.createElement(spotlight2.ImgWidget, null)),
            React.createElement(Tile, { title: spotlight3.title, subtitle: spotlight3.subtitle }, React.createElement(spotlight3.ImgWidget, null)))));
};

export { BrandclubThreeSpotlightWidget };
//# sourceMappingURL=index.js.map
